import { Component } from '@angular/core';
import { RouterExtService } from '../../services/router-ext.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-not-found-page',
    templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.scss'],
    standalone: false,
})
export class NotFoundPageComponent {
    constructor(private router: Router, private routerExt: RouterExtService) {}

    public backHandler(): void {
        const previousUrl = this.routerExt.getPreviousUrl() || '/';
        this.router.navigateByUrl(previousUrl);
    }
}
